const NEW_COUNT_PAGE: PageMapping = {
	actions: [],
	buttons: [],
	icon: "add",
	label: "New Count",
	labelKey: "nav.engage.newCount.label",
	nav: true,
	title: "New Count",
	titleKey: "nav.engage.newCount.title"
};

const HISTORY_PAGE: PageMapping = {
	actions: [],
	buttons: [],
	icon: "history",
	label: "History",
	labelKey: "nav.engage.history.label",
	nav: true,
	title: "Count History",
	titleKey: "nav.engage.history.title"
};

// Action links removed — mobile uses EngageBottomNav, desktop uses left nav sidebar.
export const featurePageMapping: { [key: string]: PageMapping } = {
	"/mobile/engage": NEW_COUNT_PAGE,
	"/mobile/engage/history": HISTORY_PAGE
};

export const flatPageMapping: { [key: string]: PageMapping } = {
	...featurePageMapping,
	"/engage": NEW_COUNT_PAGE,
	"/engage/history": HISTORY_PAGE,
	"/engage/stores": {
		actions: [],
		buttons: [],
		icon: "storefront",
		label: "Stores",
		labelKey: "nav.engage.stores.label",
		nav: false,
		title: "Stores",
		titleKey: "nav.engage.stores.title"
	}
};
